export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const API_KEY = '1c0288c8-d66e-4003-a8ef-3154147f196f';

export const TIMEOUT_SEC = 10;
export const RESULTS_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 2.5;
